module.exports = __webpack_public_path__ + "img/prove4.21aaf038.png";